import * as React from 'react';
import type { SVGProps } from 'react';
import { Ref, forwardRef, memo } from 'react';
interface SVGRProps {
  title?: string;
  titleId?: string;
  desc?: string;
  descId?: string;
}
const SvgAiSuperbarLogo = (
  {
    title,
    titleId,
    desc,
    descId,
    ...props
  }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    fill="none"
    viewBox="0 0 18 18"
    role="img"
    ref={ref}
    aria-labelledby={titleId}
    aria-describedby={descId}
    {...props}
  >
    {desc ? <desc id={descId}>{desc}</desc> : null}
    {title ? <title id={titleId}>{title}</title> : null}
    <rect width={18} height={18} fill="#111" rx={2} />
    <path
      fill="#fff"
      d="m9.225 12-.315-.99H6.57l-.315.99H4.68l2.142-6.3h1.836L10.8 12zM7.002 9.66h1.476L7.74 7.347zm4.335-3.96h1.44V12h-1.44z"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgAiSuperbarLogo);
const Memo = memo(ForwardRef);
export default Memo;
